import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const servicePointsService = new CachedService(entities.Orderadmin_DeliveryServices_Entity_ServicePoint, '/delivery-services/service-points', HALApiService, createItemsData)
